import { useEffect, useState } from "react";
import { CustomDialog } from "../../../../../../../components/dialog/v1/CustomDialog";
import { RefExcelTranslatorHeaderApi } from "../../../../../../../apis/RefExcelTranslatorHeaderApi";
import { MapperUtils } from "../../../../utils/MapperUtils";
import { useSelectedCollectedOrderDataActionsContextHook, useSelectedCollectedOrderDataValueContextHook } from "../../../../contexts/SelectedCollectedOrderDataContext";
import styled from 'styled-components';
import { CustomDateUtils } from "../../../../../../../utils/CustomDateUtils";
import CustomBlockButton from "../../../../../../../components/button/CustomBlockButton";
import { Link } from "react-router-dom";
import { SellertoolSignatureUtils } from "../../../../../../../utils/sellertool-signature-utils";
import { useApiInfoContextValueHook } from "../../../../../../../contexts/ApiInfoContext";
import { CommerceApiApi } from "../../../../../../../apis/CommerceApiApi";
import { CustomBackdropController } from "../../../../../../../components/backdrop/default/v1";
import { useCollectedOrderDatasActionsContextHook, useCollectedOrderDatasValueContextHook } from "../../../../contexts/CollectedOrderDatasContext";

const StyledContainer = styled.div`
    padding: 10px;
`;

const TableContainer = styled.div`
  overflow-x: auto;
  margin: 0;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 100%;
  max-height: 500px;
  border: 1px solid #efefef;
`

const StyledTable = styled.table`
  table-layout: auto;    /* 내용 길이에 맞춰 열 너비 자동 */
  white-space: nowrap;   /* 한 줄로 표시하여 열이 자동 확장 */
  border-collapse: collapse;
  background-color: #ffffff;

  /* width: 100%;  <-- 필요한 경우 제거하거나 조정
     min-width: 800px; <-- 원한다면 유지 (너무 좁아지지 않게)
  */
`;

const TableHeader = styled.thead`
    position: sticky;
    top: 0;
    z-index: 2;
    background-color: #f8f9fa;
`

const TableHeaderCell = styled.th`
    padding: 16px;
    text-align: left;
    font-weight: 600;
    color: #495057;
    border-bottom: 2px solid #dee2e6;
    white-space: nowrap;
    font-size: 14px;
`

const TableRow = styled.tr`
  &:nth-child(even) {
    background-color: #f8f9fa;
  }

  &:hover {
    background-color: #e9ecef;
  }
`

const TableCell = styled.td`
  padding: 16px;
  color: #495057;
  border-bottom: 1px solid #dee2e6;
  font-size: 14px;
`

const SellertoolLink = styled(Link)`
    font-weight: 600;
    color: #333;
    transition: scale .3s;
    &:hover{
        display: inline-block;
        scale: 1.1;
    }
`;

const StyledCancelEventButton = styled(CustomBlockButton)`
    background: #333;
    color: #fff;
    height: 30px;
    border-radius: 3px;
    border: none;
    font-size: 14px;
    &.confirm{
        background: var(--redColor1);
        color: #fff;
    }
`;
export function ModalCancelOrder({
    open,
    onClose,
}) {
    const apiInfoContextValueHook = useApiInfoContextValueHook();
    const collectedOrderDatasValueContextHook = useCollectedOrderDatasValueContextHook();
    const collectedOrderDatasActionsContextHook = useCollectedOrderDatasActionsContextHook();
    const selectedCollectedOrderDataValueContextHook = useSelectedCollectedOrderDataValueContextHook();
    const selectedCollectedOrderDataActionsContextHook = useSelectedCollectedOrderDataActionsContextHook();
    const currentDateTime = new Date();
    const endDateTime = CustomDateUtils().dateToYYYYMMDD(currentDateTime);
    const startDateTime = CustomDateUtils().dateToYYYYMMDD(CustomDateUtils().setPlusDate(endDateTime, 0, 0, -30));

    const [refExcelTranslatorHeaderDetailList, setRefExcelTranslatorHeaderDetailList] = useState([]);
    const [temporaryErpItems, setTemporaryErpItems] = useState([]);

    const commerceApiStoreInfo = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo;
    const cancelOrders = selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.cancelOrders;

    console.log(cancelOrders);

    useEffect(() => {
        async function fetchRefExcelTranslatorHeader() {
            const fetchResult = await RefExcelTranslatorHeaderApi().searchLatest({ params: null, headers: null })
            if (fetchResult?.content) {
                setRefExcelTranslatorHeaderDetailList(fetchResult?.content?.refExcelTranslatorHeaderDetailList);
            }
        }
        fetchRefExcelTranslatorHeader();
    }, [])

    useEffect(() => {
        if (!selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo?.id) {
            setTemporaryErpItems([]);
            return;
        }

        const mappedOrderData = MapperUtils().getMappedOrderData({ orders: cancelOrders, salesChannel: commerceApiStoreInfo?.storeName, workspaceId: null });
        setTemporaryErpItems(mappedOrderData);
    }, [selectedCollectedOrderDataValueContextHook?.selectedCollectedOrderData?.commerceApiStoreInfo?.id]);

    // TODO : 취소 처리 후 상태 변경 로직 추가해야함. 전체 주문건에 적용, 선택 주문건에 적용
    const handleCancelOrder = async (order) => {
        if (window.confirm('주문을 취소하시겠습니까?')) {
            const timestamp = Date.now().toString();
            const signature = SellertoolSignatureUtils().generateSigniture({
                apiKey: apiInfoContextValueHook?.apiInfo?.apiKey,
                secretKey: apiInfoContextValueHook?.apiInfo?.secretKey,
                timestamp: timestamp
            })

            const headers = {
                'x-sellertool-apiKey': apiInfoContextValueHook?.apiInfo?.apiKey,
                'x-sellertool-timestamp': timestamp,
                'x-sellertool-signiture': signature
            }
            const body = {
                productOrderId: order?.orderNumber1,
                commerceApiStoreInfoId: commerceApiStoreInfo?.id,
            }

            CustomBackdropController().showBackdrop();
            const apiResult = await CommerceApiApi().cancelOrder({ params: null, headers: headers, body: body });
            if (apiResult?.content) {
                // TODO : 취소 처리 후 상태 변경 로직 추가해야함. 전체 주문건에 적용, 선택 주문건에 적용
                console.log(collectedOrderDatasValueContextHook.collectedOrderDatas);
                console.log(selectedCollectedOrderDataValueContextHook.selectedCollectedOrderData);
                console.log(apiResult?.content);

                // - 수집된 주문 데이터를 업데이트
                collectedOrderDatasActionsContextHook.collectedOrderDatas.setValue(prev => {
                    return prev.map(collectedOrderData => {
                        if (collectedOrderData?.commerceApiStoreInfo?.id === commerceApiStoreInfo?.id) {
                            return {
                                ...collectedOrderData,
                                orders: collectedOrderData?.orders.filter(order => !apiResult?.content?.includes(order?.productOrderId)),
                                cancelOrders: collectedOrderData?.cancelOrders.filter(order => !apiResult?.content?.includes(order?.productOrderId))
                            }
                        }
                        return collectedOrderData;
                    });
                });

                // - 선택된 수집 주문 데이터를 업데이트
                selectedCollectedOrderDataActionsContextHook.selectedCollectedOrderData.setValue(prev => {
                    return {
                        ...prev,
                        orders: prev.orders.filter(order => !apiResult?.content?.includes(order?.productOrderId)),
                        cancelOrders: prev.cancelOrders.filter(order => !apiResult?.content?.includes(order?.productOrderId))
                    }
                });

                // - 변환된 임시 주문 데이터를 업데이트
                setTemporaryErpItems(prev => {
                    return prev.filter(order => !apiResult?.content?.includes(order?.orderNumber1));
                });
            }
            CustomBackdropController().hideBackdrop();
        }
    }

    console.log(selectedCollectedOrderDataValueContextHook)

    return (
        <>
            <CustomDialog
                open={open}
                onClose={onClose}
                maxWidth="xl"
            >
                <StyledContainer>
                    <TableContainer>
                        <StyledTable>
                            <TableHeader>
                                <tr>
                                    <TableHeaderCell>요청승인</TableHeaderCell>
                                    <TableHeaderCell>스마트스토어</TableHeaderCell>
                                    <TableHeaderCell>통합주문관리</TableHeaderCell>
                                    {refExcelTranslatorHeaderDetailList?.map((refExcelTranslatorHeaderDetail, index) => (
                                        <TableHeaderCell key={refExcelTranslatorHeaderDetail?.id}>{refExcelTranslatorHeaderDetail?.headerName}</TableHeaderCell>
                                    ))}
                                </tr>
                            </TableHeader>
                            <tbody>
                                {temporaryErpItems.map((data, rowIndex) => {
                                    return (
                                        <TableRow key={rowIndex}>
                                            <TableCell>
                                                <StyledCancelEventButton
                                                    type='button'
                                                    className="confirm"
                                                    onClick={() => handleCancelOrder(data)}
                                                >
                                                    승인
                                                </StyledCancelEventButton>
                                            </TableCell>
                                            <TableCell>
                                                <SellertoolLink
                                                    to={`https://sell.smartstore.naver.com/#/naverpay/claim/cancel?summaryInfoType=CANCEL_REQUEST`}
                                                    target="_blank"
                                                >
                                                    보기
                                                </SellertoolLink>
                                            </TableCell>
                                            <TableCell>
                                                <SellertoolLink
                                                    to={`https://v2.sellertool.io/erp/collection/integration/?classificationType=ALL&periodSearchCondition=channelOrderDate&startDateTime=${startDateTime}&endDateTime=${endDateTime}&searchFilter=[{"searchCondition":"ORDER_NUMBER_1","searchQuery":"${data?.orderNumber1}"}]&matchedCode=releaseOptionCode&page=1`}
                                                    target="_blank"
                                                >
                                                    보기
                                                </SellertoolLink>
                                            </TableCell>
                                            {refExcelTranslatorHeaderDetailList.map((refExcelTranslatorHeaderDetail, headerIndex) => {
                                                if (refExcelTranslatorHeaderDetail.fieldName === 'channelOrderDate') {
                                                    return (
                                                        <TableCell key={headerIndex}>{CustomDateUtils().dateToYYYYMMDDhhmmss(data[refExcelTranslatorHeaderDetail.fieldName])}</TableCell>
                                                    );
                                                }
                                                return (
                                                    <TableCell key={headerIndex}>{data[refExcelTranslatorHeaderDetail.fieldName]}</TableCell>
                                                );
                                            })}
                                        </TableRow>
                                    );
                                }
                                )}
                            </tbody>
                        </StyledTable>
                    </TableContainer>
                </StyledContainer>
            </CustomDialog>
        </>
    );
}